import React, { useEffect, useState } from 'react'
import DefaultLink from '../../components/DefaultLink'
import { Link } from 'react-router-dom'
import { BaseUrl } from '../../helper/BaseUrl';

export default function HomeBlog({ initialData }) {
  const [allData, setAllData] = useState(initialData || []);
  // API Calling
  const fetcher = async () => {
    try {
      const response = await fetch(`${BaseUrl}api/blogs`, {
        method: 'GET',
      });
      const result = await response.json();
      if (result.blogs === false) {
        throw new Error(`API error: ${result.message}`);
      }
      setAllData(result.blogs);
    } catch (error) {
      console.error('Fetch error:', error.message);
    }
  };
  useEffect(() => {
    fetcher();
  }, [])

  if (!allData) {
    return <div style={{ height: "100vh", width: "100%" }}></div>;
  }


  return (
    <>
      <section className="home-blog-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h3 className="heading">Our Latest Insights.</h3>
            </div>
              {allData.slice(0, 3).map((blog, i) => (
              <div key={i} className={`col-md-4 ${i === 0 ? "col-lg-6" : "col-lg-3"}`}>
                <Link to={`/blog-details/${blog?.slug}`}>
                  <div className="industry-insights">
                    <span>{blog?.category_name}</span>
                    <h4>{blog?.title?.slice(0, 60) + "..."} </h4>
                    <div> 
                      <img src={`${BaseUrl}${blog?.thumbnail}`} alt={blog?.alt_thumbnail} className="img-responsive" loading='lazy' />
                    </div>
                    <DefaultLink to={`/blog-details/${blog?.slug}`} text="Read More" />
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
